import React from 'react';

interface ScoreInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  min?: number;
  max?: number;
}

const ScoreInput: React.FC<ScoreInputProps> = ({
  value,
  onChange,
  className = '',
  placeholder = '',
  min = 0,
  max = 9
}) => {
  // Handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    if (inputValue === '' || (parseInt(inputValue) >= min && parseInt(inputValue) <= max)) {
      onChange(inputValue);
    }
  };

  return (
    <div className={`flex flex-col items-center ${className}`}>
      {/* Plus Button (Above) */}
      <button
        type="button"
        onClick={() => {
          const currentValue = value === '' ? 0 : parseInt(value);
          const newValue = Math.min(max, currentValue + 1);
          onChange(newValue.toString());
        }}
        className="group w-16 sm:w-20 h-7 flex items-center justify-center bg-gray-100 dark:bg-gray-900 hover:bg-highlight dark:hover:bg-highlight dark:text-gray-700 dark:hover:text-black transition-colors rounded-t-xl"
      >
        <svg className="w-4 h-4 text-gray-700 dark:text-gray-300 group-hover:text-black dark:group-hover:text-black" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
        </svg>
      </button>

      {/* Input field */}
      <input
        type="number"
        min={min}
        max={max}
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        className="input-field w-16 sm:w-20 text-center text-xl sm:text-2xl font-bold rounded-none px-1 sm:px-2 py-3 z-10"
        style={{
          color: 'var(--text-primary)',
          backgroundColor: 'var(--surface)',
          border: '1px solid var(--border)',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          textAlign: 'center'
        }}
      />

      {/* Minus Button (Below) */}
      <button
        type="button"
        onClick={() => {
          const currentValue = value === '' ? 0 : parseInt(value);
          const newValue = Math.max(min, currentValue - 1);
          onChange(newValue.toString());
        }}
        className="group w-16 sm:w-20 h-7 flex items-center justify-center bg-gray-100 dark:bg-gray-900 hover:bg-highlight dark:hover:bg-highlight dark:text-gray-700 dark:hover:text-black transition-colors rounded-b-xl"
      >
        <svg className="w-4 h-4 text-gray-700 dark:text-gray-300 group-hover:text-black dark:group-hover:text-black" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
        </svg>
      </button>
    </div>
  );
};

export default ScoreInput;
